export default {
  withdraw: {
    title: 'Mag-withdraw',
    subtitle: 'Mabilis, ligtas, at maginhawa',
    secureEncrypted: 'Ligtas at Naka-encrypt',
    fiatOrCash: 'Fiat/Cash',
    processing: 'Pinoproseso...',
    select: 'Pumili',
    withdrawCurrency: 'Currency ng Withdraw',
    chooseNetwork: 'Pumili ng Network',
    channel: 'Channel',
    withdrawalAddress: 'Address ng Withdrawal',
    pixKeyType: 'Uri ng PIX Key',
    accountNumber: 'Numero ng Account',
    enterAccountNumber: 'Ilagay ang numero ng iyong account',
    accountName: 'Pangalan ng Account',
    enterAccountName: 'Ilagay ang pangalan ng may-ari ng account',
    pixKey: 'PIX Key',
    enterPixKey: 'Ilagay ang iyong PIX key',
    cpf: 'CPF',
    enterCpf: 'Ilagay ang CPF',
    bankName: 'Pangalan ng Bangko',
    enterBankName: 'Ilagay ang pangalan ng bangko',
    branch: 'Sangay',
    enterBranch: 'Ilagay ang sangay (opsyonal)',
    phone: 'Telepono',
    enterPhone: 'Ilagay ang telepono (opsyonal)',
    email: 'Email',
    enterEmail: 'Ilagay ang email (opsyonal)',
    available: 'Maaaring i-withdraw',
    amountPlaceholder: 'Halaga ({unit})',
    min: 'Min',
    max: 'Max',
    totalWithdrawalAmount: 'Kabuuang halaga ng withdrawal:',
    fee: 'Bayarin:',
    withdrawalAmount: 'Halaga ng Withdrawal:',
    fundsSafeTitle: 'Ligtas ang iyong pondo sa amin',
    fundsSafeDesc: 'Gumagamit kami ng nangungunang seguridad upang protektahan ang iyong mga transaksyon at personal na impormasyon.',
    enterWithdrawalAddress: 'Mangyaring maglagay ng address ng withdrawal',
    enterAccountNumberRequired: 'Mangyaring ilagay ang numero ng iyong account',
    selectChannelRequired: 'Mangyaring pumili ng channel',
    enterAccountNameRequired: 'Mangyaring ilagay ang pangalan ng may-ari ng account',
    selectPixKeyTypeRequired: 'Mangyaring pumili ng uri ng PIX key',
    enterCpfRequired: 'Mangyaring ilagay ang CPF',
    enterValidAmount: 'Mangyaring maglagay ng wastong halaga',
    minWithdrawal: 'Pinakamababang withdrawal: {amount} {unit}',
    maxWithdrawal: 'Pinakamataas na withdrawal: {amount} {unit}',
    insufficientBalance: 'Hindi sapat ang magagamit na balanse',
    withdrawalRejected: 'Tinanggihan ang withdrawal',
    submittedPendingReview: 'Naisumite ang withdrawal, naghihintay ng pagsusuri',
    submittedPayoutInProgress: 'Naisumite ang withdrawal, isinasagawa ang payout',
    withdrawalFailed: 'Nabigo ang withdrawal',
    withdrawalFailedRetry: 'Nabigo ang withdrawal, mangyaring subukan muli',
  },
};
